import React from 'react';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';

// Título padrão das páginas: voltar (opcional), título, subtítulo e ações à direita.
const PageHeader = ({ title, subtitle, eyebrow, backTo, actions, children }) => {
  const navigate = useNavigate();

  return (
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      alignItems={{ xs: 'flex-start', md: 'center' }}
      justifyContent="space-between"
      spacing={2}
      sx={{ mb: 3 }}
    >
      <Stack direction="row" spacing={1.5} alignItems="center">
        {backTo && (
          <IconButton
            aria-label="Voltar"
            onClick={() => navigate(backTo)}
            sx={{ bgcolor: 'background.paper', border: 1, borderColor: 'divider' }}
          >
            <ArrowBackRoundedIcon />
          </IconButton>
        )}
        <Box>
          {eyebrow && (
            <Typography variant="overline" color="primary" sx={{ fontWeight: 700, lineHeight: 1.4 }}>
              {eyebrow}
            </Typography>
          )}
          <Typography variant="h4" component="h1" sx={{ lineHeight: 1.1 }}>
            {title}
          </Typography>
          {subtitle && (
            <Typography color="text.secondary" sx={{ mt: 0.5 }}>
              {subtitle}
            </Typography>
          )}
        </Box>
      </Stack>
      {(actions || children) && (
        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
          {actions}
          {children}
        </Stack>
      )}
    </Stack>
  );
};

export default PageHeader;
